module.exports = __webpack_public_path__ + "static/media/ontbijt_in_spanje.18adf59a.jpg";